import React, { useEffect, useState, useContext } from "react";
import { makeStyles } from "@material-ui/core/styles";
import ServicesContext from "../../../contexts/servicesContext";
import {
  Table,
  TableBody,
  TableCell,
  TableHead,
  TableRow,
  TablePagination,
  Button,
  Toolbar,
  Typography,
  Grid,
  Paper,
  Box,
  Popover,
  IconButton,
  Snackbar,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  MenuItem,
  Select,
  InputLabel,
  FormControl,
  FormControlLabel,
  Checkbox
} from "@material-ui/core";
import { Alert } from "@material-ui/lab";
import TablePaginationActions from "../../utils/TablePaginationActions";
import { Skeleton } from "@material-ui/lab";
import AddIcon from "@material-ui/icons/Add";
import DeleteIcon from "@material-ui/icons/Delete";
import EditIcon from "@material-ui/icons/Edit";
import PopupState, { bindTrigger, bindPopover } from "material-ui-popup-state";

const useStyles = makeStyles((theme) => ({
  seeMore: {
    marginTop: theme.spacing(3),
  },
  toolbar: {
    display: "flex",
    flexDirection: "row",
  },
  title: {
    flex: "1 1 100%",
  },
  paper: {
    padding: theme.spacing(2),
    display: "flex",
    overflow: "auto",
    flexDirection: "column",
  },
  headerDiv: {
    display: "flex",
    flexDirection: "row",
  },
  createBtn: {
    textAlign: "right",
  },
  button: {
    margin: theme.spacing(1),
  },
  dialogModal: {
    width: "500px",
    height: "220px",
  },
  textField: {
    marginLeft: theme.spacing(1),
    marginRight: theme.spacing(1),
    paddingTop: theme.spacing(1),
    width: 210,
  },
  regionSelect: {
    marginBottom: theme.spacing(1.5),
  },
  selectForm: {
    marginBottom: theme.spacing(1.5),
  },
}));

function AetDateList() {
  const rowsPerPage = 20;
  const [currentPage, setCurrentPage] = useState(0);
  const [loading, setLoading] = useState(true);
  const [dates, setDates] = useState([]);
  const [dateId, setDateId] = useState();
  const [editDate, setEditDate] = useState();
  const [datesCount, setDatesCount] = useState(0);
  const [refreshPage, setRefreshPage] = useState(false);
  const dayjs = require("dayjs");
  const [openDialog, setOpenDialog] = React.useState(false);

  const handleClickOpenDialog = () => {
    setOpenDialog(true);
  };

  const handleCloseDialog = () => {
    setOpenDialog(false);
    setDateId();
    setEditDate();
  };
  const handleSubmitDialog = () => {
    if (dateId !== null && dateId !== undefined) {
      services.aet
        .updateDate(dateId, editDate)
        .then(() => {
          setOpenDialog(false);
          setDateId();
          setEditDate();
          setShowSuccessEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        })
        .catch(() => {
          setShowErrorEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        });
    } else {
      services.aet
        .createDate(editDate)
        .then(() => {
          setOpenDialog(false);
          setDateId();
          setEditDate();
          setShowSuccessEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        })
        .catch(() => {
          setShowErrorEditNotif(true);
          setOpenEditNotif(true);
          setRefreshPage(!refreshPage);
        });
    }
  };
  const handleEditDate = (dateId) => {
    setDateId(dateId);
    handleClickOpenDialog();
  };

  useEffect(() => {
    if (dateId !== null && dateId !== undefined) {
      services.aet.getDateById(dateId).then((response) => {
        setEditDate(response.data);
      });
    }
  }, [dateId]);

  const [open, setOpen] = useState(true);
  const [showError, setShowError] = useState(false);
  const [showSuccess, setShowSuccess] = useState(false);

  const [openEditNotif, setOpenEditNotif] = useState(true);
  const [showErrorEditNotif, setShowErrorEditNotif] = useState(false);
  const [showSuccessEditNotif, setShowSuccessEditNotif] = useState(false);

  function handleClose(event, reason) {
    if (reason === "clickaway") {
      return;
    }
    setOpen(false);
    setShowError(false);
    setShowSuccess(false);
    setOpenEditNotif(false);
    setShowErrorEditNotif(false);
    setShowSuccessEditNotif(false);
  }

  const classes = useStyles();
  const services = useContext(ServicesContext);

  const handleChangePage = (event, newPage) => {
    setCurrentPage(newPage);
  };

  const handleDeleteDate = (dateId) => {
    if (dateId !== null && dateId !== undefined) {
      services.aet
        .deleteDate(dateId)
        .then(() => {
          setShowSuccess(true);
          setOpen(true);
          setRefreshPage(!refreshPage);
        })
        .catch(() => {
          setShowErrorEditNotif(true);
          setOpen(true);
          setRefreshPage(!refreshPage);
        });
    }
  };

  useEffect(() => {
    setLoading(true);
    services.aet.getAllDates().then((response) => {
      setDates(response.data);
      setLoading(false);
    });
  }, [currentPage, services, refreshPage]);

  return (
    <Paper className={classes.paper}>
      <Toolbar>
        <Grid container spacing={2}>
          <Grid item xs={12}>
            <div className={classes.headerDiv}>
              <Typography
                className={classes.title}
                variant="h6"
                id="tableTitle"
                component="div"
              >
                Даты экзаменов
              </Typography>
              <Grid item xs={12} className={classes.createBtn}>
                <Button
                  variant="outlined"
                  color="primary"
                  startIcon={<AddIcon />}
                  onClick={handleClickOpenDialog}
                >
                  Добавить дату
                </Button>
              </Grid>
            </div>
          </Grid>
        </Grid>
      </Toolbar>
      <Table aria-label="custom pagination table">
        <TableHead>
          <TableRow>
            <TableCell>№</TableCell>
            <TableCell>Регион</TableCell>
            <TableCell>Дата</TableCell>
            <TableCell>Время</TableCell>
            <TableCell>Вид Aet</TableCell>
            <TableCell align="right">Действие</TableCell>
          </TableRow>
        </TableHead>

        {loading ? (
          <TableBody>
            {[...Array(10)].map((x, i) => {
              return (
                <TableRow key={i}>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row">
                    <Skeleton variant="text" />
                  </TableCell>
                  <TableCell component="th" scope="row" align="right">
                    <Skeleton variant="text" />
                  </TableCell>
                </TableRow>
              );
            })}
          </TableBody>
        ) : (
          <TableBody>
            {dates?.map((date) => (
              <TableRow key={date?.id}>
                <TableCell component="th" scope="row">
                  {date?.id}
                </TableCell>
                <TableCell component="th" scope="row">
                  {date?.forAstana ? "Астана" : "Для других регионов"}
                </TableCell>
                <TableCell component="th" scope="row">
                  {dayjs(date?.date).format("DD-MM-YYYY")}
                </TableCell>
                <TableCell component="th" scope="row">
                  {dayjs(date?.date).format("HH:mm")}
                </TableCell>
                <TableCell component="th" scope="row">
                  {date?.isSampleTest ? "Пробный" : "Основной"}
                </TableCell>
                <TableCell component="th" scope="row" align="right">
                  <IconButton
                    aria-label="edit"
                    size="small"
                    className={classes.button}
                    onClick={() => handleEditDate(date?.id)}
                  >
                    <EditIcon />
                  </IconButton>
                  <PopupState variant="popover" popupId="demo-popup-popover">
                    {(popupState) => (
                      <>
                        <IconButton
                          aria-label="delete"
                          size="small"
                          className={classes.button}
                          {...bindTrigger(popupState)}
                        >
                          <DeleteIcon />
                        </IconButton>
                        <Popover
                          {...bindPopover(popupState)}
                          anchorOrigin={{
                            vertical: "bottom",
                            horizontal: "center",
                          }}
                          transformOrigin={{
                            vertical: "top",
                            horizontal: "center",
                          }}
                        >
                          <Box p={2}>
                            <Typography>
                              Вы уверены, что хотите удалить?
                            </Typography>
                            <Button
                              variant="outlined"
                              className={classes.button}
                              size="small"
                              onClick={() => {
                                popupState.close();
                                handleDeleteDate(date?.id);
                              }}
                            >
                              да
                            </Button>
                            <Button
                              variant="outlined"
                              className={classes.button}
                              size="small"
                              onClick={popupState.close}
                            >
                              нет
                            </Button>
                          </Box>
                        </Popover>
                      </>
                    )}
                  </PopupState>
                </TableCell>
              </TableRow>
            ))}
          </TableBody>
        )}
      </Table>
      <TablePagination
        count={datesCount}
        rowsPerPage={rowsPerPage}
        page={currentPage}
        component="div"
        rowsPerPageOptions={[]}
        onChangePage={handleChangePage}
        ActionsComponent={TablePaginationActions}
      />
      <Dialog
        open={openDialog}
        onClose={handleCloseDialog}
        aria-labelledby="form-dialog-title"
      >
        <DialogTitle id="form-dialog-title">
          {dateId ? "Редактирование" : "Добавить новую дату экзамена"}
        </DialogTitle>
        <DialogContent className={classes.dialogModal}>
          {editDate ? (
            <>
              <FormControl fullWidth className={classes.selectForm}>
                <InputLabel id="region">Регион</InputLabel>
                <Select
                  labelId="region"
                  value={editDate?.forAstana}
                  onChange={(e) => {
                    const forAstana = e.target.value;
                    setEditDate((prevRegion) => ({
                      ...prevRegion,
                      forAstana: forAstana,
                    }));
                  }}
                  className={classes.regionSelect}
                >
                  <MenuItem value={true}>Астана</MenuItem>
                  <MenuItem value={false}>Другие регионы</MenuItem>
                </Select>
              </FormControl>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    id="date"
                    label="Введите дату дату и время"
                    type="datetime-local"
                    value={editDate?.date}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    onChange={(e) => {
                      const date = e.target.value;
                      setEditDate((prevRegion) => ({
                        ...prevRegion,
                        date: date,
                      }));
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    id="regEndDate"
                    label="Введите дату и время окончания регистрации на экзамен"
                    type="datetime-local"
                    value={editDate?.regEndDate}
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    onChange={(e) => {
                      const regEndDate = e.target.value;
                      setEditDate((prevRegion) => ({
                        ...prevRegion,
                        regEndDate: regEndDate,
                      }));
                    }}
                  />
                </Grid>
              </Grid>
              <FormControl fullWidth className={classes.selectForm}>
                <InputLabel id="isSampleTest">Вид aet</InputLabel>
                <Select
                  labelId="isSampleTest"
                  value={editDate?.isSampleTest}
                  onChange={(e) => {
                    const isSampleTest = e.target.value;
                    setEditDate((prevRegion) => ({
                      ...prevRegion,
                      isSampleTest: isSampleTest,
                    }));
                  }}
                  className={classes.regionSelect}
                >
                  <MenuItem value={true}>Пробный</MenuItem>
                  <MenuItem value={false}>Основной</MenuItem>
                </Select>
                </FormControl>
            </>
          ) : (
            <>
              <FormControl fullWidth className={classes.selectForm}>
                <InputLabel id="region">Регион</InputLabel>
                <Select
                  fullWidth
                  labelId="region"
                  onChange={(e) => {
                    const forAstana = e.target.value;
                    setEditDate((prevRegion) => ({
                      ...prevRegion,
                      forAstana: forAstana,
                    }));
                  }}
                  className={classes.regionSelect}
                >
                  <MenuItem value={1}>Астана</MenuItem>
                  <MenuItem value={0}>Другие регионы</MenuItem>
                </Select>
              </FormControl>
              <Grid container spacing={3}>
                <Grid item xs={12} sm={12}>
                  <TextField
                    id="date"
                    label="Введите дату и время экзамена"
                    type="datetime-local"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    onChange={(e) => {
                      const date = e.target.value;
                      setEditDate((prevRegion) => ({
                        ...prevRegion,
                        date: date,
                      }));
                    }}
                  />
                </Grid>
                <Grid item xs={12} sm={12}>
                  <TextField
                    id="regEndDate"
                    label="Введите дату и время окончания регистрации на экзамен"
                    type="datetime-local"
                    InputLabelProps={{
                      shrink: true,
                    }}
                    fullWidth
                    onChange={(e) => {
                      const regEndDate = e.target.value;
                      setEditDate((prevRegion) => ({
                        ...prevRegion,
                        regEndDate: regEndDate,
                      }));
                    }}
                  />
                </Grid>
              </Grid>
              <FormControl fullWidth className={classes.selectForm}>
                <InputLabel id="isSampleTest">Вид aet</InputLabel>
                <Select
                  fullWidth
                  labelId="isSampleTest"
                  onChange={(e) => {
                    const isSampleTest = e.target.value;
                    setEditDate((prevRegion) => ({
                      ...prevRegion,
                      isSampleTest: isSampleTest,
                    }));
                  }}
                  className={classes.regionSelect}
                >
                  <MenuItem value={1}>Пробный</MenuItem>
                  <MenuItem value={0}>Основной</MenuItem>
                </Select>
              </FormControl>
            </>
          )}
        </DialogContent>
        <DialogActions>
          <Button onClick={handleSubmitDialog} color="primary">
            {dateId ? "Изменить" : "Сохранить"}
          </Button>
          <Button onClick={handleCloseDialog} color="primary">
            Отмена
          </Button>
        </DialogActions>
      </Dialog>
      {showError && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="warning"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Не удалось удалить!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showSuccess && (
        <div>
          <Snackbar
            open={open}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Успешно удален!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showErrorEditNotif && (
        <div>
          <Snackbar
            open={openEditNotif}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="warning"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Не удалось сохранить данные!
            </Alert>
          </Snackbar>
        </div>
      )}
      {showSuccessEditNotif && (
        <div>
          <Snackbar
            open={openEditNotif}
            autoHideDuration={3000}
            onClose={handleClose}
            anchorOrigin={{
              vertical: "bottom",
              horizontal: "left",
            }}
            ContentProps={{
              "aria-describedby": "message-id",
            }}
          >
            <Alert
              onClose={handleClose}
              severity="success"
              variant="filled"
              elevation={6}
              sx={{ width: "100%" }}
            >
              Данные успешно сохранены!
            </Alert>
          </Snackbar>
        </div>
      )}
    </Paper>
  );
}
export default AetDateList;

const convertDateFormat = (inputDate) => {
  const [day, month, year] = inputDate.split("-");
  const formattedDate = `${year}-${month}-${day}`;
  return formattedDate;
};
